import { render, staticRenderFns } from "./LogoSFC.vue?vue&type=template&id=d2dd2888"
import script from "./LogoSFC.vue?vue&type=script&lang=js"
export * from "./LogoSFC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports